import * as React from "react";
import { IconProps } from "./types";

export const ChevronDownDoubleIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M7 13L12 18L17 13M7 6L12 11L17 6"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ChevronDownDoubleIcon as React.FunctionComponent).displayName =
  "ChevronDownDoubleIcon";

export default ChevronDownDoubleIcon;
